module.exports = __webpack_public_path__ + "assets/src/style/img/footer-zero-one.png?55bf8b9667b9004a36322c304ab85ecc";